export default __webpack_public_path__ + "static/zakaria-c5962c7e66169ac5bfa202df3c160eba.jpg";